export function PerChiLavoriamo() {
  const clienti = [
    {
      icon: '🏢',
      title: 'PMI e Grandi Aziende',
      description: 'Supportiamo le aziende nella valorizzazione del brand per bilanci consolidati, operazioni di M&A e pianificazione strategica a lungo termine.',
    },
    {
      icon: '📋',
      title: 'Commercialisti e Revisori',
      description: 'Forniamo perizie difendibili e metodologie certificate per supportare i professionisti nelle valutazioni richieste dai loro clienti.',
    },
    {
      icon: '📈',
      title: 'Consulenti Strategici',
      description: 'Offriamo strumenti avanzati e metodologie scientifiche per arricchire l\'offerta dei consulenti nelle valutazioni aziendali.',
    },
    {
      icon: '💼',
      title: 'Investitori e Fondi',
      description: 'Facilitiamo le due diligence con valutazioni precise degli asset intangibili e assessment completi del valore del brand.',
    },
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 mb-4">
            Per Chi Lavoriamo
          </h2>
          <p className="text-base lg:text-lg text-gray-600 max-w-3xl mx-auto px-4">
            Brand Capital è la soluzione per diverse tipologie di aziende e professionisti che necessitano di valutazioni precise e difendibili
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
          {clienti.map((cliente, index) => (
            <div key={index} className="bg-white rounded-xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-start space-x-4 sm:space-x-6">
                <div className="w-12 h-12 sm:w-14 sm:h-14 bg-green-100 rounded-full flex items-center justify-center text-xl sm:text-2xl flex-shrink-0">
                  {cliente.icon}
                </div>
                
                <div className="flex-1">
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3">
                    {cliente.title}
                  </h3>
                  <p className="text-sm lg:text-base text-gray-600 leading-relaxed">
                    {cliente.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}